import React, { Component } from 'react';
//import os from 'os'
//import localIpV4Address from 'local-ipv4-address'
import { UserInfo } from './UserInfo'
import { AssessmentSteps } from './AssessmentSteps'
import { GetIndicatorData } from './services/getIndicatorData'
import { GetIndustryData } from './services/getIndustryData'
import { GetGeoInformation } from './services/getGeoInformation'
import { PostCowAssessment } from './services/postCowAssessment'
import { AssessmentCharts } from './AssessmentCharts'
import { Industry } from './Industry'
import { Activities } from './Activities'
import Spinner from './common/Spinner'

import './styles/custom.css';
import './styles/Assessment.css';

export class Assessment extends Component {
    constructor(props) {
        super(props)
        this.state = {
            Name: "",
            Ranch: "",
            State: "",
            Address: "",
            Date: new Date().toDateString(),
            Region: "",
            IPAddress: "",
            processSteps: 0,
            processTotalSteps: 0,
            currentStep: 0,
            currentSubStep: 0,
            currentPercent: 1,
            assessmentFinish: false,
            data: [],
            loading: true,
            AssessmentResults: [],
            ActivityId: "",
            IsAdmin: false,
            testip: "",
            showLogActivities: false,
            IndustryId: 0,
            IndustryData: [],
            randomArray:[]
        }
    }
    componentDidMount() {
        this.loadIndustryData();
    };
    loadIndustryData() {
        let getIndustryData = new Promise((resolve, reject) => {
            GetIndustryData(resolve, reject)
        })
        getIndustryData.then((data) => {
            if (data.length > 0) {
                this.setState({
                    IndustryData: data,
                    loading: false,
                })
            }
        })
    }
    loadIndicatorData(id) {
        let getIndicatorData = new Promise((resolve, reject) => {
            GetIndicatorData(resolve, reject, id)
        })
        getIndicatorData.then((data) => {
            if (data.length > 0) {
                let totalsteps = 0
                data.map((indicator) => {
                    return totalsteps += indicator.keyPerformanceIndicators.length
                })
                this.setState({
                    data: data,
                    loading: false,
                    processTotalSteps: totalsteps,
                })
                for (let i = 0; i <= totalsteps; i++) {
                    let rnd = Math.random() * 10
                    this.setState(previousState => ({
                        randomArray: [...previousState.randomArray, rnd]
                    }))
                }
            }
        })

        //let getGeoInformation = new Promise((resolve, reject) => {
        //    GetGeoInformation(resolve, reject)
        //}).catch(e => { console.log(e) })
        //getGeoInformation.then((data) => {
        //    this.setState({
        //        IPAddress: data,
        //        IsAdmin: data.indexOf('199.253.0') === 0 ? true : false,
        //    })
        //}).catch(e => { console.log(e) })
    };
    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }
    handleStateChange = (e) => {
        this.setState({ State: e.value })
    }
    handleStartAssession = () => {
        let currentStep = 1
        let currentSubStep = 0
        let processSteps = 1
        this.setState(previousState => ({
            currentStep: currentStep,
            currentSubStep: currentSubStep,
            processSteps: processSteps,
            currentPercent: 100 * processSteps / this.state.processTotalSteps,
            AssessmentResults: [...previousState.AssessmentResults, "0"] //initial
        }))
    }
    handleSave = (state) => {
        if (this.state.data.length > 0) {
            let currentStep = this.state.currentStep
            let currentSubStep = this.state.currentSubStep
            let stepSize = this.state.data.length


            let subStepSize = this.state.data[currentStep - 1].keyPerformanceIndicators.length - 1
            if (currentSubStep >= subStepSize) {
                currentStep += 1
                currentSubStep = 0
            }
            else {
                currentSubStep += 1
            }

            if (currentStep > stepSize) {  // if finish
                this.setState({
                    currentStep: currentStep,
                    currentPercent: 100,
                    assessmentFinish: true
                })

                //save to database
                let postCowAssement = new Promise((resolve, reject) => {
                    PostCowAssessment(resolve, reject, this.state, state)
                })
                postCowAssement.then((response) => {
                    //get the id
                    this.setState({ ActivityId: response.id })
                })
            }
            else {
                this.setState({
                    currentStep: currentStep,
                    currentSubStep: currentSubStep,
                })
            }

            //save the assessment results
            let processSteps = 1
            //calculate how many steps before
            this.state.data.map((indicator, index) => {
                if (index < currentStep - 1) {
                    return processSteps += this.state.data[index].keyPerformanceIndicators.length
                }
            })
            processSteps += currentSubStep

            this.setState({
                processSteps: processSteps,
                currentPercent: 100 * processSteps / this.state.processTotalSteps,
            })
        }
    }
    handleBack = (state) => {
        let currentStep = this.state.currentStep
        let currentSubStep = this.state.currentSubStep

        //update steps
        if (currentSubStep > 0) {
            currentSubStep -= 1
        } else {
            if (currentStep === 1) {
                currentStep = 0
            }
            else if (currentStep > 1) {
                let newSubStepSize = this.state.data[currentStep - 2].keyPerformanceIndicators.length - 1
                currentSubStep = newSubStepSize
                currentStep -= 1
            }
        }

        //save state changes
        this.setState({
            currentStep: currentStep,
            currentSubStep: currentSubStep,
        })

        //save the assessment results
        let processSteps = 1
        //calculate how many steps before
        this.state.data.map((indicator, index) => {
            if (index < currentStep - 1) {
                return processSteps += this.state.data[index].keyPerformanceIndicators.length
            }
        })
        processSteps += currentSubStep
        this.setState({
            processSteps: processSteps,
            currentPercent: 100 * processSteps / this.state.processTotalSteps,
        })
    }
    updateSelectedOption = (id) => {
        if (this.state.AssessmentResults[this.state.processSteps] || this.state.processSteps < this.state.AssessmentResults.length) {
            let sliceArray = this.state.AssessmentResults.slice();
            sliceArray[this.state.processSteps] = id
            this.setState({
                AssessmentResults: sliceArray
            })
        } else {
            this.setState(previousState => ({
                AssessmentResults: [...previousState.AssessmentResults, id]
            }))
        }
    }
    handleReset = () => { 
            this.setState({
                IndustryId: 0,
                processSteps: 0,
                currentStep: 0,
                currentSubStep: 0,
                currentPercent: 1,
                assessmentFinish: false,
                AssessmentResults: [-1]
            })
    }
    moveToNextIndicator = () => {
        let currentStep = this.state.currentStep
        currentStep += 1;
        this.setState({
            currentStep: currentStep,
            currentSubStep: 0,
        })
    }
    //handleBackToAssement = () => {
    //    this.setState({
    //        showLogActivities: false
    //    })
    //}
    //handleSelectedResult = (value) => {
    //    this.setState({
    //        AssessmentResults: value,
    //        showLogActivities: false,
    //        assessmentFinish: true,
    //        currentStep: this.state.data.length + 1,
    //    })
    //}
    handleIndustrySelection = (id) => {
        this.setState({
            IndustryId: id,
            loading:true
        })
        this.loadIndicatorData(id);
    }
    render() {
        let AssessmentStep
        if (!this.state.loading) {
            if (this.state.IndustryId === 0) {
                AssessmentStep = (
                    <Industry
                        updateSelectedOption={this.handleIndustrySelection}
                        state={this.state}
                        {...this.props} />
                )
            }
            //else if (this.state.showLogActivities) {
            //    AssessmentStep = (
            //        <Activities
            //            handleBackToAssement={this.handleBackToAssement}
            //            handleSelectedResult={this.handleSelectedResult}
            //            state={this.state}
            //            {...this.props} />
            //    )
            //}
            else if (this.state.currentStep === 0) {
                AssessmentStep = <UserInfo
                    handleChange={this.handleChange}
                    handleSave={this.handleStartAssession}
                    handleReset={this.handleReset}
                    handleStateChange={this.handleStateChange}
                    state={this.state}
                    {...this.props} />
            }
            else if (this.state.currentStep <= this.state.data.length) {
                AssessmentStep = <AssessmentSteps
                    handleSave={this.handleSave}
                    handleBack={this.handleBack}
                    handleReset={this.handleReset}
                    moveToNext={this.moveToNextIndicator}
                    updateSelectedOption={this.updateSelectedOption}
                    state={this.state}
                    {...this.props} />

            }
            else if (this.state.assessmentFinish) {
                AssessmentStep = (
                    <React.Fragment >
                        <AssessmentCharts                           
                            handleReset={this.handleReset}
                            state={this.state}
                            {...this.props} />
                    </React.Fragment>
                )
            }
        }
        else {
            AssessmentStep = (
                <Spinner />)
        }

        //let ipcontent
        //if (this.state.IsAdmin) {
        //    ipcontent = (
        //        <h5>{this.state.IPAddress}</h5>)
        //}
        return (
            <main className="container">
                <h1 className="header">USRSB - Self Assessment</h1>{this.state.testip}
                {AssessmentStep}
            </main>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Assessment.js